import React, { Component } from 'react'
import Slider from 'react-id-swiper'
import PropTypes from 'prop-types'
import GalleryPicture from './GalleryPicture'
import './style.css'

class GallerySlider extends Component {
  static propTypes = {
    gallery: PropTypes.arrayOf(PropTypes.shape({})),
    dotColor: PropTypes.string
  }

  componentDidMount () {
    this.setPaginationColor()
  }

  componentDidUpdate () {
    this.gallerySlider && this.gallerySlider.update()
    this.gallerySlider && this.gallerySlider.slideToLoop(0, 0, false)
  }

  setPaginationColor = () => {
    const { dotColor } = this.props
    const paginationLinks = document.getElementsByClassName('swiper-gallery-pagination-bullet')
    const paginationLinkActive = document.getElementsByClassName('swiper-gallery-pagination-bullet__active')
    paginationLinks && Array.from(paginationLinks).map(item => (item.setAttribute('style', `background: ${dotColor};`)))
    paginationLinks && Array.from(paginationLinkActive).map(item => (item.setAttribute('style', `border-color: ${dotColor}; background: transparent;`)))
  }

  render () {
    const { gallery } = this.props
    const gallerySliderParams = {
      initialSlide: 0,
      slidesPerView: 1,
      speed: 1200,
      allowTouchMove: true,
      autoplay: true,
      effect: 'fade',
      direction: 'horizontal',
      on: {
        transitionStart: () => this.gallerySlider && this.setPaginationColor()
      },
      pagination: {
        el: '.swiper-gallery-pagination',
        bulletClass: 'swiper-gallery-pagination-bullet',
        bulletActiveClass: 'swiper-gallery-pagination-bullet__active',
        clickable: true
      },
      getSwiper: (sw) => { this.gallerySlider = sw }
    }

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <Slider
          {...gallerySliderParams}
          className='gal-sw'
        >
          {
            gallery && gallery.map(img => (
              <div key={Math.random()} className='gallery-img-wrapper'>
                <GalleryPicture
                  {...img}
                />
              </div>
            ))
          }
        </Slider>
      </div>
    )
  }
}

export default GallerySlider
